
// ======================================================
// STATE
// ======================================================
let currentHandle = null;
const mediaCache = {};


// ======================================================
// ELEMENTS
// ======================================================
const productFlavorTitle = document.querySelector(
  '.product__title.liv-main-product-title .flavor'
);
const productDescription = document.querySelector('.liv-body-text');
const amazonProductLink = document.querySelector('.liv-pdp-cta a');


// ======================================================
// MEDIA
// ======================================================
async function fetchMediaSection(handle, apply = true) {
  if (!handle) return;

  if (mediaCache[handle]) {
    if (apply) applyMediaSection(mediaCache[handle]);
    return;
  }

  const res = await fetch(`/products/${handle}`);
  if (!res.ok) return;

  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');

  mediaCache[handle] = doc;

  if (apply) applyMediaSection(doc);
}

async function updateStoreSection(handle) {
  try {
    const res = await fetch(`/products/${handle}`);

    if (!res.ok) return;

    const html = await res.text();

    const doc = new DOMParser().parseFromString(html, 'text/html');

    const storeDataScript = doc.querySelector(
      'script[data-product-data]'
    );

    const amazonCTA = document.querySelector('.liv-pdp-cta');
    const amazonLink = amazonCTA?.querySelector('a');

    if (!storeDataScript) {
      renderStores({ stores: [] });

      if (amazonCTA) {
        amazonCTA.style.display = 'none';
      }

      return;
    }

    const product = JSON.parse(storeDataScript.textContent);

    renderStores({
      stores: product.stores || []
    });

    // Amazon button
  // Amazon button
if (amazonCTA && amazonLink) {

  if (product.amazon_link) {

    amazonCTA.classList.add('show-amazon-cta');

    amazonLink.href = product.amazon_link;
    amazonLink.classList.remove('disabled');
    amazonLink.setAttribute('target', '_blank');

  } else {

    amazonCTA.classList.remove('show-amazon-cta');

    amazonLink.href = '#';
    amazonLink.classList.add('disabled');
    amazonLink.removeAttribute('target');

  }

}

  } catch (error) {
    console.error('Store update failed:', error);
  }
}

function renderStores(product) {
  const section = document.querySelector('.liv-available-in-store');
  const container = document.querySelector(
    '.liv-available-in-store .link-containers'
  );

  if (!section || !container) return;

  container.innerHTML = '';

  // Hide section when no stores
  if (!product.stores || !product.stores.length) {
    section.classList.remove('show-store-section');
    return;
  }

  // Show section when stores exist
  section.classList.add('show-store-section');

  product.stores.forEach(store => {
    container.insertAdjacentHTML(
      'beforeend',
      `
      <a href="${store.url}" target="_blank" class="store-link">
        <img
          src="${store.logo}"
          alt="${store.name}"
          class="store-logo"
        >
      </a>
      `
    );
  });
}


function renderPackButtons(product, handle) {
  const container = document.querySelector('.pack-buttons.it');
  if (!container) return;

  container.innerHTML = '';

  if (!product.pack_sizes) {
    container.style.display = 'none';
    return;
  }

  const packs = product.pack_sizes
    .split(',')
    .map(size => size.trim())
    .filter(Boolean);

  if (!packs.length) {
    container.style.display = 'none';
    return;
  }

  container.style.display = '';

  const currentPack = handle.match(/(\d+)pk/i)?.[1];

  packs.forEach(size => {
    const button = document.createElement('button');

    button.className = 'pack-button it';
    if (size === currentPack) {
      button.classList.add('active');
    }

    button.dataset.packSize = size;
    button.innerHTML = `<span class="size">${size}</span> Sticks`;

    container.appendChild(button);
  });
}

function applyMediaSection(doc) {
  const oldGallery = document.querySelector('media-gallery');
  const newGallery = doc.querySelector('media-gallery');

  if (!oldGallery || !newGallery) return;

  // =====================================================
  // 1. REMOVE OLD PRODUCT MEDIA MODAL (CRITICAL FIX)
  // =====================================================
  const oldModal = document.querySelector('product-modal');
  if (oldModal) oldModal.remove();

  // =====================================================
  // 2. REPLACE WHOLE MEDIA GALLERY
  // =====================================================
  const clonedGallery = newGallery.cloneNode(true);
  oldGallery.replaceWith(clonedGallery);

  const mediaGallery = document.querySelector('media-gallery');

  // =====================================================
  // 3. RE-INJECT MODAL FROM NEW PRODUCT
  // =====================================================
  const newModal = doc.querySelector('product-modal');
  if (newModal) {
    const clonedModal = newModal.cloneNode(true);
    document.body.appendChild(clonedModal);
  }

  // =====================================================
  // 4. SAFE FIRST MEDIA ACTIVATION
  // =====================================================
  const slider = mediaGallery.querySelector('[id^="Slider-Gallery"]');
  const firstMedia = slider?.querySelector('[data-media-id]');

  if (!firstMedia) return;

  requestAnimationFrame(() => {
    mediaGallery.setActiveMedia?.(firstMedia, true);
  });

  // =====================================================
  // 5. FORCE DAWN RE-INIT HOOKS
  // =====================================================
  document.dispatchEvent(
    new CustomEvent('shopify:section:load', {
      bubbles: true
    })
  );
}


// ======================================================
// PRODUCT DATA
// ======================================================
function loadProduct(handle) {
  if (!handle) return;

  const product = window.productData?.[handle];

  if (!product) {
    // Hide store section
    document.querySelector('.liv-available-in-store')?.style.setProperty('display', 'none');
    return;
  }

  productFlavorTitle.textContent = product.title || '';
  productDescription.innerHTML = product.description || '';

  if (amazonProductLink) {
    amazonProductLink.href = product.product_amazon_link || '#';
  }

  updateAccordionContent(product);
  renderPackButtons(product, handle);
updateStoreSection(handle);
}


// ======================================================
// ACCORDION
// ======================================================
function updateAccordionContent(product) {
  if (!product?.accordions) return;

  const tabContents = document.querySelectorAll('.tabcontent');

  tabContents.forEach((tab, index) => {
    if (product.accordions[index]) {
      tab.innerHTML = `<p>${product.accordions[index].content || ''}</p>`;
    }
  });

  document.querySelectorAll('.tablinks').forEach((btn, i) => {
    btn.classList.toggle('active', i === 0);
  });

  tabContents.forEach((tab, i) => {
    tab.style.display = i === 0 ? 'block' : 'none';
  });

  document.querySelectorAll('.liv-pdp-accordions-mobile .accordion__content')
    .forEach((el, i) => {
      if (product.accordions[i]) {
        el.innerHTML = `<p>${product.accordions[i].content || ''}</p>`;
      }
    });

  document.querySelectorAll('.liv-pdp-accordions-mobile details')
    .forEach(d => d.removeAttribute('open'));
}


// ======================================================
// CORE RENDER
// ======================================================
function renderProduct(handle) {
  if (!handle) return;

  if (handle === currentHandle) return;

  currentHandle = handle;

  fetchMediaSection(handle);
  loadProduct(handle);
}


// ======================================================
// NAVIGATION
// ======================================================
function updateProduct(handle) {
  renderProduct(handle);

  window.history.pushState(
    {},
    '',
    `/products/${handle}`
  );
}


// ======================================================
// MOBILE DROPDOWN
// ======================================================
function initMobileDropdown() {
  const dropdown = document.querySelector('.liv-flavor-selection');
  if (!dropdown) return;

  const selected = dropdown.querySelector('.selected-item');
  const label = dropdown.querySelector('.label');
  const options = dropdown.querySelectorAll('.options li');

  selected.addEventListener('click', () => {
    dropdown.classList.toggle('open');
  });

  document.addEventListener('click', (e) => {
    if (!dropdown.contains(e.target)) {
      dropdown.classList.remove('open');
    }
  });

  options.forEach(option => {
    option.addEventListener('click', (e) => {
      e.stopPropagation();

      label.innerHTML = option.innerHTML;
      dropdown.classList.remove('open');

      const handle = option.getAttribute('handle');
      if (handle) updateProduct(handle);
    });
  });
}

initMobileDropdown();


function openTab(evt, tabItem) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  document.getElementById(tabItem).style.display = "block";
  evt.currentTarget.className += " active";
}


// ======================================================
// FLAVOR + PACK (IDENTICAL BEHAVIOR)
// ======================================================
document.addEventListener('change', (e) => {
  if (!e.target.matches('input[name="flavor"]')) return;

  const handle = e.target.getAttribute('handle');
  if (handle) updateProduct(handle);
});

document.addEventListener('click', (e) => {
  const btn = e.target.closest('button[data-pack-size]');
  if (!btn) return;

  const handle = btn.getAttribute('handle');
  if (handle) updateProduct(handle);
});



window.addEventListener('popstate', () => {
  console.log('popstate', window.location.pathname);

  let handle = window.location.pathname
    .split('/products/')[1]
    ?.split('?')[0];

  if (!handle) return;

  handle = decodeURIComponent(handle);

  console.log('Extracted handle:', handle);

  // 🔥 update product UI
  renderProduct(handle);

  // ======================================================
  // SYNC FLAVOR INPUTS
  // ======================================================
  document.querySelectorAll('input[name="flavor"]').forEach(input => {
    const inputHandle = input.getAttribute('handle');

    if (inputHandle === handle) {
      input.checked = true;
    }
  });

  // ======================================================
  // SYNC PACK BUTTONS (if you use data-pack-size)
  // ======================================================
  const packMatch = handle.match(/(\d+)pk$/);
  const packSize = packMatch?.[1];

  if (packSize) {
    document.querySelectorAll('button[data-pack-size]').forEach(btn => {
      btn.classList.toggle(
        'active',
        btn.dataset.packSize === packSize
      );
    });
  }


  // ======================================================
// SYNC MOBILE DROPDOWN
// ======================================================
const dropdown = document.querySelector('.liv-flavor-selection');

if (dropdown) {
  const label = dropdown.querySelector('.label');
  const options = dropdown.querySelectorAll('.options li');

  options.forEach(option => {
    const optionHandle = option.getAttribute('handle');

    // active class sync (optional)
    option.classList.toggle(
      'active',
      optionHandle === handle
    );

    // update selected label
    if (optionHandle === handle && label) {
      label.innerHTML = option.innerHTML;
    }
  });
}
});


document.addEventListener('click', (e) => {
  const btn = e.target.closest('button[data-pack-size]');
  console.log('Pack button clicked:', btn);
  if (!btn) return;

  const packSize = btn.dataset.packSize;
  if (!packSize) return;

  // current product handle
  let handle = currentHandle;

  // fallback from URL
  if (!handle) {
    handle = window.location.pathname
      .split('/products/')[1]
      ?.split('?')[0];
  }

  if (!handle) return;

  // replace existing XXpk
  const newHandle = handle.replace(/\d+pk/i, `${packSize}pk`);

  console.log('OLD:', handle);
  console.log('NEW:', newHandle);

  updateProduct(newHandle);
  updateStoreSection(newHandle);

  // optional active class sync
  document.querySelectorAll('button[data-pack-size]').forEach(b => {
    b.classList.toggle(
      'active',
      b.dataset.packSize === packSize
    );
  });
});